// import $ from 'jquery';
const accordion = (btn, elementOpen, classBlockEl, classBtnEl, parrentBlock = false, isCta = false) => {
  if(btn.length < 1) return;
  btn.on('click', function (e) {
    e.preventDefault();
    let btnThis = $(this);
    let menuMobile = btnThis.next(elementOpen);
    let idTitle = $(this).attr('data-id-img');

    if (btnThis.hasClass(classBtnEl)) {
      menuMobile.slideUp({
        duration: 400,
        complete: function () {
          menuMobile.removeClass(classBlockEl);
          btnThis.removeClass(classBtnEl);
          if(isCta) {
            $('.cta-text-image-block__wrapper .left-column .icon.number-icon-'+idTitle).removeClass('active');
          }
        },
      });
    } else {
      $('.'+classBtnEl).removeClass(classBtnEl);
      $('.'+classBlockEl).slideUp({duration: 400}).removeClass(classBlockEl);
      if(isCta) {
        $('.cta-text-image-block__wrapper .left-column .icon').removeClass('active');
      }
      if(parrentBlock) {
        btnThis.addClass(classBtnEl);
      }
      menuMobile.slideDown({
        duration: 400,
        complete: function () {
          menuMobile.addClass(classBlockEl);
          if(isCta) {
            $('.cta-text-image-block__wrapper .left-column .icon.number-icon-'+idTitle).addClass('active');
          }
          !parrentBlock ? btnThis.addClass(classBtnEl) : '';
        },
      });
    }
  });
}
export default accordion;
